/** Tolerância padrão: 1 centavo (R$ 0,01). */
export const TOLERANCIA_CENTAVOS_PADRAO = 1;

/**
 * Normaliza valor para centavos inteiros (fluxo de caixa / CurrencyInput).
 */
export const toCentavos = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n);
};

/**
 * Indica divergência entre saldo informado e calculado (comparação em centavos).
 */
export const haDivergenciaMonetaria = (
  informado,
  calculado,
  toleranciaCentavos = TOLERANCIA_CENTAVOS_PADRAO,
) => {
  const inf = toCentavos(informado);
  const calc = toCentavos(calculado);
  return Math.abs(inf - calc) > toleranciaCentavos;
};

/** Diferença em centavos: informado − calculado. */
export const diferencaCentavos = (informado, calculado) =>
  toCentavos(informado) - toCentavos(calculado);

/** Saldo físico informado é exatamente R$ 0,00. */
export const saldoInformadoEhZero = (informado) => toCentavos(informado) === 0;

/** Observações obrigatórias apenas quando há divergência monetária real. */
export const exigeObservacoesFechamento = (informado, calculado) =>
  haDivergenciaMonetaria(informado, calculado);
